export default class BasePage{
    constructor(info) {
        this.ele = info.ele;
        this.direction = '';
        this.showMotion = new TimelineMax({paused: true, onComplete:()=>{this._showComplete()}});
        this.hideMotion = new TimelineMax({paused: true});
        this.evt = {
            onComplete: document.createEvent('Event'),
            hideComplete: document.createEvent('Event')
        };
        this.evt.onComplete.initEvent( 'onComplete', false, false);
        this.evt.hideComplete.initEvent( 'hideComplete', false, false);
    }

    set(){
        this.hideMotion
            .fromTo( this.ele, 0.7, { autoAlpha: 1 }, { autoAlpha: 0 })
            .call(()=>{ this._hideComplete() }, null, null, '-=0.5');



        this.showMotion
            .set( this.ele, { clearProps: "y, transformPerspective" })
            .fromTo( this.ele, 1, { autoAlpha: 0 }, { autoAlpha: 1 })
    }

    show(){
        this.showMotion.seek(0);
        this.showMotion.play();
    }

    _showComplete(){
        this.ele.dispatchEvent( this.evt.onComplete );
    }

    hide(){
        this.hideMotion.seek(0);
        this.hideMotion.play();
    }

    _hideComplete(){
        this.ele.dispatchEvent( this.evt.hideComplete );
    }
}


// WEBPACK FOOTER //
// ./src/js/subDeath/subBasePage.js